import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import login, { LoginState } from './login/loginReducer'
import autoSuggest, { AutoSuggestState } from './autoSuggest/autoSuggestReducer'
import networkStatus, {
  NetworkStatusState
} from './networkStatus/networkStatusReducer'
import ui, { UiState } from './ui/uiReducer'
import quiz, { QuizState } from './quiz/quizReducer'
import gradPlanner, { GradPlannerState } from './gradPlanner/gradPlannerReducer'
export default combineReducers({
  login,
  autoSuggest,
  ui,
  quiz,
  gradPlanner,
  networkStatus,
  form: formReducer
})

export type State = {
  login: LoginState,
  autoSuggest: AutoSuggestState,
  ui: UiState,
  quiz: QuizState,
  networkStatus: NetworkStatusState,
  gradPlanner: GradPlannerState
}



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js